import { format } from 'date-fns';

export const formatDate = (isoString: string) => {
  return format(new Date(isoString), 'MMM dd, yyyy');
};

export const formatDateTime = (isoString: string) => {
  return format(new Date(isoString), 'MMM dd, yyyy h:mm aa');
};
